
const HelpIcon = ({ className, style }) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        style={style}
    >
        <path
            d="M14.1641 2.02539H5.83073C3.33073 2.02539 1.66406 3.69206 1.66406 6.19206V11.1921C1.66406 13.6921 3.33073 15.3587 5.83073 15.3587V17.1337C5.83073 17.8004 6.5724 18.2004 7.1224 17.8254L10.8307 15.3587H14.1641C16.6641 15.3587 18.3307 13.6921 18.3307 11.1921V6.19206C18.3307 3.69206 16.6641 2.02539 14.1641 2.02539ZM9.9974 12.1671C9.6474 12.1671 9.3724 11.8837 9.3724 11.5421C9.3724 11.2004 9.6474 10.9171 9.9974 10.9171C10.3474 10.9171 10.6224 11.2004 10.6224 11.5421C10.6224 11.8837 10.3474 12.1671 9.9974 12.1671ZM11.0474 8.70873C10.7224 8.9254 10.6224 9.06707 10.6224 9.3004V9.4754C10.6224 9.81707 10.3391 10.1004 9.9974 10.1004C9.65573 10.1004 9.3724 9.81707 9.3724 9.4754V9.3004C9.3724 8.33372 10.0807 7.85872 10.3474 7.67539C10.6557 7.46706 10.7557 7.32539 10.7557 7.10872C10.7557 6.69206 10.4141 6.35039 9.9974 6.35039C9.58073 6.35039 9.23906 6.69206 9.23906 7.10872C9.23906 7.45039 8.95573 7.73372 8.61406 7.73372C8.2724 7.73372 7.98906 7.45039 7.98906 7.10872C7.98906 6.00039 8.88906 5.10039 9.9974 5.10039C11.1057 5.10039 12.0057 6.00039 12.0057 7.10872C12.0057 8.05872 11.3057 8.53373 11.0474 8.70873Z"
            fill="currentColor"
        />
    </svg>
);

export default HelpIcon;
